// Layout Script for Ghost Gallery Cards (from documentation)
var images = document.querySelectorAll('.kg-gallery-image img');
images.forEach(function (image) {
    var container = image.closest('.kg-gallery-image');
    var width = image.attributes.width.value;
    var height = image.attributes.height.value;
    var ratio = width / height;
    container.style.flex = ratio + ' 1 0%';
})

/*
* foreach.js
* ---------
* Version : 1.1.0
* Repo    : github.com/toddmotto/foreach
* Author  : Todd Motto @toddmotto
* License : MIT
*/
var forEach=function(a,b,c){if("[object Object]"===Object.prototype.toString.call(a))for(var d in a)Object.prototype.hasOwnProperty.call(a,d)&&b.call(c,a[d],d,a);else for(var e=0,f=a.length;f>e;e++)b.call(c,a[e],e,a)};

/* Reset Try */
if (dropdownToggle) {
  forEach(dropdownToggle, function(r) {
        if (r.parentNode.classList.contains('smc-nav-dropdown--current')) {
          document.body.classList.add('smc-nav-dropdown--is-closed');
          r.parentNode.classList.remove('smc-nav-dropdown--current');
          document.body.classList.remove('smc-nav-dropdown--is-open');
        }
        else {
          // do nothing.
        }
  });
}

/* Custom settings for foreach.js */
var mobileMenuIsOpen = 0;
var mobileMenu = document.querySelectorAll('.smc-menu-state');
if (mobileMenu) {
    forEach(mobileMenu, function(e) {
        e.addEventListener('click', function() {

            this.classList.toggle('smc-menu--is-open');

            if (this.classList.contains('smc-menu--is-open')) {
              document.body.classList.remove('smc-menu--is-closed');
              document.body.classList.remove('smc-nav-dropdown--is-open');
              document.body.classList.add('smc-menu--is-open');
              document.body.classList.add('smc-nav-dropdown--is-closed');
            }
            else {
              document.body.classList.remove('smc-menu--is-open');
              document.body.classList.remove('smc-nav-dropdown--is-open');
              document.body.classList.add('smc-menu--is-closed');
              document.body.classList.add('smc-nav-dropdown--is-closed');
            }

        }, false);
    });
}
/* Hover function */
function hover(element, className){
  element.addEventListener('mouseenter', e => element.classList.add(className))
  element.addEventListener('mouseleave', e => element.classList.remove(className))
}
/* Dropdown Menu */
// var dropdownItem = document.querySelectorAll('.smc-nav-dropdown-state');
var dropdownToggle = document.querySelectorAll('.smc-nav-dropdown-toggle');
if (dropdownToggle) {
    forEach(dropdownToggle, function(e) {
        e.addEventListener('click', function() {
          if (document.body.classList.contains('smc-nav-dropdown--is-closed')) {
            document.body.classList.remove('smc-nav-dropdown--is-closed');
            document.body.classList.add('smc-nav-dropdown--is-open');
            this.parentNode.classList.add('smc-nav-dropdown--current');
          }
          else if (this.parentNode.classList.contains('smc-nav-dropdown--current')) {
            document.body.classList.add('smc-nav-dropdown--is-closed');
            this.parentNode.classList.remove('smc-nav-dropdown--current');
            document.body.classList.remove('smc-nav-dropdown--is-open');
          }
          else {
            // do nothing.
          }
        }, false);
    });
}

function reset() {
  forEach(dropdownToggle, function(r) {
    if (r.parentNode.classList.contains('smc-nav-dropdown--current')) {
      r.parentNode.classList.remove('smc-nav-dropdown--current');
    }
  });
  forEach(mobileMenu, function(r) {
    if (r.classList.contains('smc-menu--is-open')) {
      r.classList.remove('smc-menu--is-open');
    }
  });
  if (document.body.classList.contains('smc-nav-dropdown--is-open')) {
    document.body.classList.remove('smc-nav-dropdown--is-open');
    document.body.classList.add('smc-nav-dropdown--is-closed');
  }
  if (document.body.classList.contains('smc-menu--is-open')) {
    document.body.classList.remove('smc-menu--is-open');
    document.body.classList.add('smc-menu--is-closed');
  }
  return false;
}
window.onpageshow = function(event) {
  // console.log('All assets are loaded');
  reset();
  // console.log('Reset done');
}

/* scroll eventListener adding body-class "smc-header--is-fixed"*/
const header = document.querySelector('.smc-stage--header');
const stages = document.querySelector('.smc-view');
const headerTop = header.offsetHeight;

function stickyHeader() {
//  console.log('navTop = ' + navTop);
//  console.log('scrollY = ' + window.scrollY);

  if (window.scrollY >= headerTop) {
    // header offsetHeight = height of header
    // document.body.style.paddingTop = header.offsetHeight + 'px';
    stages.classList.remove('smc-header--is-not-fixed');
    document.body.classList.remove('smc-header--is-not-fixed');
    stages.classList.add('smc-header--is-fixed');
    document.body.classList.add('smc-header--is-fixed');
  } else {
    // document.body.style.paddingTop = 0;
    stages.classList.remove('smc-header--is-fixed');
    document.body.classList.remove('smc-header--is-fixed');
    stages.classList.add('smc-header--is-not-fixed');
    document.body.classList.add('smc-header--is-not-fixed');
  }
}

window.addEventListener('scroll', stickyHeader);

// javascript "page back" solution via history.back
// var element = document.getElementById('smc_link_back');
var element = document.getElementById('smc_link_back');

if (element) {
    element.setAttribute('href', document.referrer);

    element.onclick = function() {
    history.go(-1);
    return false;
    }
}